/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const StreakInvitationStatus = {
    PENDING: 'PENDING',
    ACCEPTED: 'ACCEPTED',
    DECLINED: 'DECLINED',
    EXPIRED: 'EXPIRED'
} as const;
export type StreakInvitationStatus = typeof StreakInvitationStatus[keyof typeof StreakInvitationStatus];


export function instanceOfStreakInvitationStatus(value: any): boolean {
    for (const key in StreakInvitationStatus) {
        if (Object.prototype.hasOwnProperty.call(StreakInvitationStatus, key)) {
            if (StreakInvitationStatus[key as keyof typeof StreakInvitationStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function StreakInvitationStatusFromJSON(json: any): StreakInvitationStatus {
    return StreakInvitationStatusFromJSONTyped(json, false);
}

export function StreakInvitationStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): StreakInvitationStatus {
    return json as StreakInvitationStatus;
}

export function StreakInvitationStatusToJSON(value?: StreakInvitationStatus | null): any {
    return value as any;
}

export function StreakInvitationStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): StreakInvitationStatus {
    return value as StreakInvitationStatus;
}

